const EVENT_TRACKING_NAME = 'MaintenanceBoard';
const EVENT_TRACKING_ACTIONS = {
  upcomingClicked: 'upcomingClicked',
  dueClicked: 'dueClicked',
  upcomingDueClicked: 'upcomingDueClicked',
  exportCSVClicked: 'exportCSVClicked',
  inputChanged: 'inputChanged',
  completeClicked: 'completeClicked',
  paginationChanged: 'paginationChanged',
  tableOrderChanged: 'tableOrderChanged',
  assetNameClicked: 'assetNameClicked',
  planNameClicked: 'planNameClicked',
  completeModalClosed: 'completeModalClosed',
  completeModalResolved: 'completeModalResolved',
  topDuePlanClicked: 'topDuePlanClicked',
  topUpcomingPlanClicked: 'topUpcomingPlanClicked',
};
// Add to data layer
const addToDataLayer = data => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data },
  });
};
export default function MaintenanceBoardController(
  $scope,
  $filter,
  MaintenanceService,
  gettextCatalog,
) {
  'ngInject';

  $scope.filterData = true;
  $scope.filterStatus = 2;
  $scope.selectedStatus = 'Upcoming';
  $scope.loading = true;
  $scope.filtering = true;
  $scope.dataAvailable = false;
  $scope.okay = true;
  $scope.query = '';

  //Local Variables
  $scope.search = {
    text: '',
  };
  $scope.statusData = [];
  $scope.filteredStatusData = [];
  $scope.statusDataByPage = [];

  //Sorting
  $scope.predicate = 'equipment.name';
  $scope.reverse = true;
  var orderBy = $filter('orderBy');


  //Sort filteredStatusData
  $scope.orderStatusData = function(predicate, onLoad) {
    $scope.predicate = predicate;

    if (!onLoad) {
      $scope.reverse = $scope.predicate === predicate ? !$scope.reverse : false;
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.tableOrderChanged,
        propertyOrder: predicate,
        descending: $scope.reverse,
      });
    }

    angular.forEach($scope.filteredStatusData, function(statusEntry) {
      statusEntry[predicate] = statusEntry[predicate];
    });
    $scope.filteredStatusData = orderBy($scope.filteredStatusData, predicate, $scope.reverse);

    $scope.displayStatusDataByPage();
  };

  $scope.completeMaintenancePlan = (statusEntry) => {
    const {
      equipment,
      plan
    } = statusEntry;

    // Maintance Tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.completeClicked,
      equipmentId: equipment.id,
      planId: plan.id
    });

    const equipmentData = {
      data: {
        id: equipment.id,
        attributes: equipment,
      },
    };

    const planData = {
      id: plan.id,
      attributes: plan,
    };

    MaintenanceService
      .showPopupForEquipmentPlan(equipmentData.data, planData)
      .result
      .then(
        (response) => {
          addToDataLayer({
            action: EVENT_TRACKING_ACTIONS.completeModalResolved
          });
          refresh();

        },
        (reason) => {
          addToDataLayer({
            action: EVENT_TRACKING_ACTIONS.completeModalClosed,
            reason: reason || '',
          });
        }
      );

  };

  //Pagination
  $scope.current = {
    statusPage: 1,
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //displaySecurityGroupsByPage() is used to set the legnth of paging needed for filteredSecurityGroups.
  $scope.displayStatusDataByPage = function() {
    $scope.totalItems = $scope.filteredStatusData.length;
    var begin = ($scope.current.statusPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.statusDataByPage = $scope.filteredStatusData.slice(begin, end);
    $scope.loading = false;
    $scope.filtering = false;
  };

  //Calls displaySecurityGroupsByPage(), everytime the the user changes the page.
  $scope.pageChanged = function() {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.paginationChanged,
      currentPage: $scope.current.statusPage || 0
    });
    $scope.displayStatusDataByPage();
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = () => {

    if ($scope.search.text) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.inputChanged,
      });
    }

    // Ignore case search input
    const regSearch = new RegExp($scope.search.text, 'i');

    $scope.filteredStatusData = $scope.statusData.filter(data => {
      const {
        equipment: { name: equipmentName = '' },
        nextService: { runHour = 0 },
        plan: { name: planName = '' },
        status: { description = '' },
      } = data;

      return (
        regSearch.test(equipmentName) ||
        regSearch.test(runHour) ||
        regSearch.test(planName) ||
        regSearch.test(description)
      );
    });

    $scope.displayStatusDataByPage();
  };

  var drawMaintenanceChart = function() {
    var numOfUpcoming = $scope.aggregateData.upcomingEquipmentCount;
    var numOfOthers = $scope.aggregateData.dueEquipmentCount;
    var percentage = $scope.aggregateData.upcomingEquipmentPercent;

    if (numOfUpcoming == 0 && numOfOthers == 0) {
      numOfOthers = 100;
      percentage = 0;
    }

    var width = 100;
    var height = 100;
    var radius = 50;
    var donutWidth = 10;

    var svg = d3
      .select('#donutchartMaintenance')
      .append('svg')
      .attr('style', 'margin-left:auto; margin-right:auto; display:block;')
      .attr('width', width)
      .attr('height', height);

    var g = svg.append('g').attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

    var text = g
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('style', 'font-size:2.0em;')
      .attr('dy', '0.5em');

    text.text('' + percentage + '%');

    var arc = d3.svg
      .arc()
      .innerRadius(radius - donutWidth) // UPDATED
      .outerRadius(radius);

    var pie = d3.layout
      .pie()
      .value(function(d) {
        return d.count;
      })
      .sort(null);

    var dataset = [
      {
        product: 'Maintenance Plans',
        count: numOfUpcoming,
        color: '#1e88e5',
      },
      {
        product: 'Other',
        count: numOfOthers,
        empty: true,
        color: '#BDBDBD',
      },
    ];

    var slices = pie(dataset);

    var path = g
      .selectAll('path')
      .data(slices)
      .enter()
      .append('path')
      .attr('class', 'slice')

      .attr('d', arc)
      .attr('fill', function(d, i) {
        return d.data.color;
      });
  };

  var drawDueMaintenanceChart = function() {
    var numOfDue = $scope.aggregateData.dueEquipmentCount;
    var numOfOthers = $scope.aggregateData.upcomingEquipmentCount;
    var percentage = $scope.aggregateData.dueEquipmentPercent;

    if (numOfDue == 0 && numOfOthers == 0) {
      numOfOthers = 100;
      percentage = 0;
    }

    var width = 100;
    var height = 100;
    var radius = 50;
    var donutWidth = 10;

    var svg = d3
      .select('#donutchartDue')
      .append('svg')
      .attr('style', 'margin-left:auto; margin-right:auto; display:block;')
      .attr('width', width)
      .attr('height', height);

    var g = svg.append('g').attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

    var text = g
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('style', 'font-size:2.0em;')
      .attr('dy', '0.5em');

    text.text('' + percentage + '%');

    var arc = d3.svg
      .arc()
      .innerRadius(radius - donutWidth) // UPDATED
      .outerRadius(radius);

    var pie = d3.layout
      .pie()
      .value(function(d) {
        return d.count;
      })
      .sort(null);

    var dataset = [
      {
        product: 'Maintenance Plans',
        count: numOfDue,
        color: '#ffb74d',
      },
      {
        product: 'Other',
        count: numOfOthers,
        empty: true,
        color: '#BDBDBD',
      },
    ];

    var slices = pie(dataset);

    var path = g
      .selectAll('path')
      .data(slices)
      .enter()
      .append('path')
      .attr('class', 'slice')

      .attr('d', arc)
      .attr('fill', function(d, i) {
        return d.data.color;
      });
  };

  var myReadyHandlerTwo = function() {
    //alert('worked!');
  };

  $scope.topFive = [];

  $scope.differenceArray = [];

  $scope.setPage = function(pageNo) {
    $scope.currentPage = pageNo;
  };

  $scope.pageChanged = function() {
    // $log.log('Page changed to: ' + $scope.currentPage);
    $scope.displayStatusDataByPage();
  };

  $scope.search = function(asset) {
    if ($scope.query.length <= 0) return true;
    var query = ('' + $scope.query).toLowerCase(),
      fullname = [asset.equipment.name].join(' ').toLowerCase();
    return fullname.indexOf(query) > -1;
  };

  //ON INIT
  //$scope.statusData = [];
  $scope.upcomingCounter = 0;
  $scope.dueCounter = 0;
  $scope.requireMaintenance = 0;

  var handleGetStatusError = function(error) {
    var errorMsg = gettextCatalog.getString(
      'An error occurred while retrieving maintenance status data',
    );
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = error.data.message + ' ' + error.status.toString();
      } else {
        errorMsg += ': ' + error.status.toString();
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.statusErrorFlag = true;
    $scope.statusErrorText = errorMsg;
    $scope.loading = false;
  };

  var refresh = function() {
    MaintenanceService.getStatus().then(function(response) {
      $scope.statusData = [];

      for (let i = 0; i < response.data.length; i++) {
        const description = response.data[i].status.description.toLowerCase();
        if (description === 'upcoming' || description === 'due') {
          $scope.statusData.push(response.data[i]);
        }
      }

      if ($scope.statusData.length > 0) {
        $scope.dataAvailable = true;
      } else {
        $scope.dataAvailable = false;
      }

      $scope.filteredStatusData = $scope.statusData.slice();
      $scope.orderStatusData($scope.predicate, true);
      $scope.loading = false;
      $scope.displayStatusDataByPage();
      if ($scope.search.text && $scope.filteredStatusData.length >= 0) $scope.applyFilter();
    }, handleGetStatusError);

    //no need to chain these, they are not dependent on each other
    MaintenanceService.getDashboardAggregate().then(
      function(response) {
        if (angular.element('#donutchartMaintenance').length) {
          $scope.aggregateData = response.data;

          //add percentages ( use to be in api )
          var total =
            $scope.aggregateData.dueEquipmentCount + $scope.aggregateData.upcomingEquipmentCount;

          $scope.aggregateData.upcomingEquipmentPercent = Math.round(
            ($scope.aggregateData.upcomingEquipmentCount / total) * 100,
          );
          $scope.aggregateData.dueEquipmentPercent =
            100 - $scope.aggregateData.upcomingEquipmentPercent;

          drawMaintenanceChart();
          drawDueMaintenanceChart();

          $scope.loading = false;
        }
      },
      function(error) {
        var errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving maintenance chart data',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + error.status.toString();
          } else {
            errorMsg += ': ' + error.status.toString();
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.chartErrorFlag = true;
        $scope.chartErrorText = errorMsg;
        $scope.loading = false;
      },
    );
  };

  //CSV file
  $scope.getCsvFileName = function() {
    if (!$scope.statusData) return '';

    var fileName = gettextCatalog.getString('data_export');
    var name = gettextCatalog.getString('Overdue&Upcoming Maintenance Plans');
    fileName += '.' + name;
    return fileName + '.csv';
  };

  $scope.getCsvData = () => {
    // Maintenance GTM tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.exportCSVClicked,
    });

    const filteredCSVData = $scope.filteredStatusData || [];

    let csvData = [].concat({
      Asset: 'Asset',
      Plan: 'Plan',
      Status: 'Status',
      'Last Serviced': 'Last Serviced',
      'Next Service': 'Next Service'
    });

    filteredCSVData.forEach(data => {
      const {
        equipment: { name: equipmentName = '' },
        plan: { name: planName = '' },
        status: { description = '' },
        lastService,
        nextService 
      } = data;

      let csvLastServiced = lastService ? $filter('TableDateFilter')(lastService.date):'';
      let csvNextService = nextService ? $filter('TableDateFilter')(nextService.date):'';

      if (nextService && nextService.runHour) {
        if (lastService) 
          csvLastServiced += ` at ${lastService.runHour} runhours`;

        if (nextService)
          csvNextService += ` or ${nextService.runHour} runhours`;
      }

      csvData.push({
        Asset: equipmentName,
        Plan: planName,
        Status: description,
        'Last Serviced': csvLastServiced,
        'Next Service': csvNextService
      });
    });

    return csvData;
  };

  var filterMaintenanceOnStatus = function(statusCode) {
    $scope.filterArray = [];
    MaintenanceService.getStatus(null, null, statusCode).then(function(response) {
      $scope.result = response.data;
      for (var i = 0; i < response.data.length; i++) {
        $scope.filterArray.push($scope.result[i]);
      }
      if ($scope.filterArray.length == 0) {
        $scope.filterData = false;
      } else {
        $scope.filterData = true;
      }
      $scope.statusData = $scope.filterArray;
      //$scope.bigTotalItems = $scope.statusData.length;

      $scope.filtering = false;

      $scope.filteredStatusData = $scope.statusData;
      $scope.orderStatusData($scope.predicate, true);

      $scope.displayStatusDataByPage();
      if ($scope.search.text && $scope.filteredStatusData.length >= 0) {
        $scope.applyFilter();
      }
    }, handleGetStatusError);
  };

  $scope.upcomingClicked = function() {
    const upcomingSelected = $scope.upcoming;
    $scope.upcoming = !upcomingSelected;
    $scope.filtering = true;

    // Maintenance tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.upcomingClicked,
      selected: $scope.upcoming,
    });

    if (upcomingSelected) {
      if ($scope.both) {
        $scope.both = !$scope.both;
        $scope.due = false;
        $scope.dueClicked();
      } else refresh();
    } else {
      $scope.filterStatus = 2;
      $scope.selectedStatus = 'Upcoming';

      if ($scope.due) $scope.bothClicked();
      else filterMaintenanceOnStatus($scope.filterStatus);
    }
  };

  $scope.bothClicked = () => {
    const both = $scope.both;

    $scope.upcoming = !both;
    $scope.due = !both;
    $scope.both = !both;
    $scope.filtering = true;
    $scope.selectedStatus = null;
    $scope.filterStatus = 0;

    // Maintenace Tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.upcomingDueClicked,
      selected: $scope.both,
    });
    refresh();
  };

  $scope.dueClicked = () => {
    const dueSelected = $scope.due;

    $scope.filtering = true;
    $scope.due = !$scope.due;

    // Maintenace Tracking
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.dueClicked,
      selected: $scope.due,
    });

    if (dueSelected) {
      if ($scope.both) {
        $scope.both = false;
        $scope.upcoming = false;
        $scope.upcomingClicked();
      } else refresh();
    } else {
      $scope.filterStatus = 4;
      $scope.selectedStatus = 'Due';
      if ($scope.upcoming) $scope.bothClicked();
      else filterMaintenanceOnStatus($scope.filterStatus);
    }
  };

  $scope.toggleOptions = () => {
    if ($scope.due && $scope.upcoming) $scope.bothClicked();
    else {
      if ($scope.both) {
        $scope.both = false;

        if ($scope.upcoming) {
          $scope.upcoming = false;
          $scope.upcomingClicked();
        }

        if ($scope.due) {
          $scope.due = false;
          $scope.dueClicked();
        }
      }
      if ($scope.due) {
        $scope.filterStatus = 4;
        $scope.selectedStatus = 'Due';
        filterMaintenanceOnStatus($scope.filterStatus);
      }
      if ($scope.upcoming) {
        $scope.filterStatus = 2;
        $scope.selectedStatus = 'Upcoming';
        filterMaintenanceOnStatus($scope.filterStatus);
      } else refresh();
    }
  };

  $scope.assetNameClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.assetNameClicked,
      equipmentId: id
    })
  };

  $scope.planNameClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.planNameClicked,
      planId: id
    })
  };

  $scope.topDuePlanClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.topDuePlanClicked,
      planId: id
    })
  }

  $scope.topUpcomingPlanClicked = (id) => {
    addToDataLayer({
      action: EVENT_TRACKING_ACTIONS.topUpcomingPlanClicked,
      planId: id
    })
  }
  refresh();
}
